import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// import en from '../public/translations/en/translation.json';
// import es from '../public/translations/es/translation.json';
// import fr from '../public/translations/fr/translation.json';

const resources = {
  'en': {translation: require('../public/translations/en/translation.json')},
  'es': {translation: require('../public/translations/es/translation.json')},
  'fr': {translation: require('../public/translations/fr/translation.json')},
}


i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;
